export default function() {
  const getInvoiceCheck = document.querySelector('.js-invoice-requested');
  const getInvoiceInfoWrapper = document.querySelector('.js-invoice-info--wrapper');
  const getInvoiceCheckWrapper = document.querySelector('.js-invoice-check--wrapper');

  if (getInvoiceCheck) {
    if (getInvoiceCheck.checked === true) {
      getInvoiceInfoWrapper.classList.remove('hide');
      getInvoiceCheckWrapper.classList.remove('input-group__no-margin');
    }

    getInvoiceCheck.addEventListener('click', () => {
      getInvoiceInfoWrapper.classList.toggle('hide');
      getInvoiceCheckWrapper.classList.toggle('input-group__no-margin');

      if (
        getInvoiceCheck.checked === false &&
        document.querySelector('.js-invoice-company').value !== '' &&
        document.querySelector('.js-invoice-vat').value !== ''
      ) {
        document.querySelector('.js-invoice-company').value = '';
        document.querySelector('.js-invoice-vat').value = '';
      }
    });
  }
}
